/**
 * estado-display.ts — PR-E E-T4 — S-11.1, S-11.2, S-11.3
 *
 * Pure helper: maps (estado, isLocalOnly) to the display label shown in
 * TechnicianPanel. "Pendiente" is a DISPLAY derivation only — it is NOT a
 * database state and does not exist in the estado enum.
 *
 * isLocalOnly: true when the report has no serverId (en_cola but not yet
 * flushed to the server). After sync, estado becomes "sincronizado" and the
 * "Pendiente" label disappears automatically (no special case needed there).
 *
 * ponytail: pure function, zero side effects.
 */
import type { EstadoInforme } from "@/features/reports/index.js";

/** Canonical label for each DB estado (no "pendiente" key — S-11.3). */
export const DISPLAY_ESTADO_LABEL: Record<EstadoInforme, string> = {
  borrador: "Borrador",
  en_cola: "En cola",
  sincronizado: "Sincronizado",
  enviado: "Enviado",
};

/**
 * Returns the display label for a report row.
 * @param estado — the report's DB estado
 * @param isLocalOnly — true when the report has no serverId (not yet synced)
 */
export function resolveDisplayEstado(estado: EstadoInforme, isLocalOnly: boolean): string {
  if (estado === "en_cola" && isLocalOnly) return "Pendiente";
  return DISPLAY_ESTADO_LABEL[estado];
}
